import { ChallengesSection } from "Components/Loyalty/Shared/Challenges/ChallengesSection";
import type { LoyaltyTabId } from "Components/Loyalty/Shared/Tabs/config";
import { Tabs, type TabItem } from "Components/Loyalty/Shared/Tabs/Tabs";
import { LeaderboardSection } from "Components/Loyalty/Stardust/LeaderboardSection";
import { RewardsSection } from "Components/Loyalty/Stardust/RewardsSection";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Loyalty.Tabs;

type Props = {
  initialTab: LoyaltyTabId | null;
  onTabChange: (activeTab: LoyaltyTabId) => void;
};

export const StardustTabs = ({ initialTab, onTabChange }: Props) => {
  const { t } = useResource();

  const tabs: Array<TabItem> = [
    {
      id: "challenges",
      label: t(RESOURCES.Challenges),
      content: <ChallengesSection />,
    },
    {
      id: "leaderboard",
      label: t(RESOURCES.Leaderboard),
      content: <LeaderboardSection />,
    },
    {
      id: "rewards",
      label: t(RESOURCES.Rewards),
      content: <RewardsSection />,
    },
  ];

  return <Tabs initialTab={initialTab} onTabChange={onTabChange} tabs={tabs} />;
};
